package meineglasfaser.frontend.www.pages.portal

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.client.plugins.*
import io.ktor.http.*
import meineglasfaser.api.routes.AuthRoutes.RealmCustomerPortal.ChangeEmail
import meineglasfaser.api.routes.AuthRoutes.RealmCustomerPortal.ChangePassword
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.GlobalCustomerState
import meineglasfaser.frontend.www.components.LocalCustomerState
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.PortalLayout")
@Composable
fun MyAccountPage() {
    val baseInfo = LocalCustomerState.current.accountInfoOrNull() ?: return

    YaForm(
        initial = ChangeEmail.RequestBody(baseInfo.accountEmail),
        onSubmitScope = { data ->
            val body = ChangeEmail.RequestBody(
                newEmail = data.string(ChangeEmail.RequestBody::newEmail),
            )
            BackendApi.post(ChangeEmail()) {
                withAuth()
                setJsonBody(body)
            }.fold(
                onSuccess = {
                    Toasts.display(Toast.success("E-Mail-Änderung erfolgreich. Bitte verifizieren Sie Ihre neue E-Mail-Adresse, um die Änderung zu bestätigen."))
                    GlobalCustomerState.value = CustomerState.Indeterminate
                },
                onFailure = { error ->
                    when (error) {
                        is ClientRequestException -> when (error.response.status) {
                            HttpStatusCode.Forbidden -> {
                                Toasts.display(Toast.error("Die angegebene E-Mail-Adresse wird bereits verwendet"))
                            }
                            else -> {
                                Toasts.display(Toast.error("Fehler beim Ändern der E-Mail-Adresse: ${error.response.status}"))
                            }
                        }
                        else -> {
                            Toasts.display(Toast.error("Fehler beim Ändern der E-Mail-Adresse: ${error.message}"))
                        }
                    }
                }
            )
        }
    ) {
        Article {
            Header { Text("E-Mail-Adresse ändern") }
            if (!baseInfo.accountEmailVerified) {
                Article({ classes("bg-warn") }) {
                    Text("Ihre aktuelle E-Mail-Adresse (${baseInfo.accountEmail}) ist noch nicht verifiziert. Bitte verifizieren Sie diese, um alle Funktionen nutzen zu können.")
                }
            }
            YaFormTextInput(
                prop = ChangeEmail.RequestBody::newEmail,
                label = { Text("Neue E-Mail-Adresse") },
                type = InputType.Email,
                required = true,
            )
            val cannotSubmit = state.data[ChangeEmail.RequestBody::newEmail.name] == baseInfo.accountEmail
            YaFormButton(ButtonType.Submit, disabled = cannotSubmit) {
                Text("E-Mail ändern & Bestätigung senden")
            }
        }
    }

    YaForm(
        onSubmitScope = { data ->
            val body = ChangePassword.RequestBody(
                currentPassword = data.string(ChangePassword.RequestBody::currentPassword),
                newPassword = data.string(ChangePassword.RequestBody::newPassword),
                newPasswordRepeat = data.string(ChangePassword.RequestBody::newPasswordRepeat),
            )
            BackendApi.post(ChangePassword()) {
                withAuth()
                setJsonBody(body)
            }.fold(
                onSuccess = {
                    Toasts.display(Toast.success("Passwort erfolgreich geändert"))
                },
                onFailure = { error ->
                    when (error) {
                        is ClientRequestException if error.response.status == HttpStatusCode.Forbidden -> {
                            Toasts.display(Toast.error("Aktuelles Passwort stimmt nicht mit Eingabe überein"))
                        }
                        else -> {
                            Toasts.display(Toast.error("Fehler beim Ändern des Passworts: ${error.message}"))
                        }
                    }
                }
            )
        }
    ) {
        Article {
            Header { Text("Passwort ändern") }
            YaFormTextInput(
                prop = ChangePassword.RequestBody::currentPassword,
                label = { Text("Aktuelles Passwort") },
                type = InputType.Password,
                required = true,
            )
            YaFormTextInput(
                prop = ChangePassword.RequestBody::newPassword,
                label = { Text("Neues Passwort") },
                type = InputType.Password,
                required = true,
            )
            YaFormTextInput(
                prop = ChangePassword.RequestBody::newPasswordRepeat,
                label = { Text("Neues Passwort (Wiederholung)") },
                type = InputType.Password,
                required = true,
            )
            val cannotSubmit = (state.data[ChangePassword.RequestBody::currentPassword.name]?.toString() ?: "").isEmpty()
                || (state.data[ChangePassword.RequestBody::newPassword.name]?.toString() ?: "").isEmpty()
                || (state.data[ChangePassword.RequestBody::newPasswordRepeat.name]?.toString() ?: "").isEmpty()
            YaFormButton(ButtonType.Submit, disabled = cannotSubmit) {
                Text("Passwort ändern")
            }
        }
    }

    Article {
        Header { Text("Antrag auf Auskunft und Löschung personenbezogener Daten") }
        val mailto = "mailto:office@prometheus-network.at"
        Section {
            Text("Auskunft über alle personenbezogenen Daten")
            Br()
            Anchor(mailto) { Text("Antrag stellen") }
        }
        Hr()
        Section {
            Text("Löschung des Kundenkontos und aller personenbezogenen Daten")
            Br()
            Anchor(mailto) { Text("Antrag stellen") }
        }
    }
}
